import { BaseLayout } from '@components/Layout';
import { getGuideById, getGuides, SingleGuidePageComponent, SingleGuidePageProps } from '@milo/react';

const GuidePage = (props: SingleGuidePageProps) => {
  return (
    <BaseLayout stickyNavigation showFooter={false}>
      <SingleGuidePageComponent {...props} />
    </BaseLayout>
  );
};

export const getStaticPaths = async () => {
  const guides = await getGuides();
  const paths = guides.map((guide) => ({
    params: { slug: guide.slug },
  }));

  return {
    paths,
    fallback: false,
  };
};

export async function getStaticProps(context: any) {
  const params = context?.params;
  const slug = params?.slug as string;
  const id = Number(slug.split('-').slice(-1)[0]);
  const guide = await getGuideById(id);

  if (!guide?.id) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      guide,
      seo: {
        title: guide?.title as string,
        description: guide?.meta_description,
        imagePath: guide?.main_image_url || null,
      },
    },
  };
}

export default GuidePage;
